import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, Switch, Route, Redirect } from 'react-router-dom';

import Editor from './editor/editor-main';
import { Session as SessionType } from '../../../../types/working-model';
import {
	loadWorkingSession,
} from '../../../../store/actions/admin/create-event/session';
import {
	clearWorkingEvent,
	loadWorkingEvent,
} from '../../../../store/actions/admin/create-event';
import WaitingIndicator from '../../../general-ui/waiting-indicator/waiting-indicator';
import usePrevious from '../../../../utils/use-previous';
import { PATHNAMES } from '../../admin';
import useTranslationModules from '../../../../i18n/useTranslationModules';
import EventHeader from '../../header/event-header';
import Panel from '../homepage/navigation/panel/panel';
import { useTypedSelector } from '../../../../store/reducers/use-typed-selector';
import Assistant from '../assistant/assistant';
import { getDefaultLanguageCode } from '../../../../utils/get-language';
import './session.scss';

function findSession(uuid: string) {
	return (session: SessionType) => {
		return session.uuid === uuid;
	};
}

export default function Session(): JSX.Element {
	const { id, session, language }: { id: string, session: string, language: string; } = useParams();
	const {
		CreateSessionReducer: { workingSession },
		CreateEventReducer: { workingEvent, loadingEvent },
		AuthReducer: { token },
	} = useTypedSelector(state => state);

	// use the session default language, else set to english
	useTranslationModules({ language } || getDefaultLanguageCode(workingSession));

	const [loading] = useState(false);
	const dispatch = useDispatch();

	usePrevious(language);
	usePrevious(id);

	useEffect(() => {
		dispatch(clearWorkingEvent());
		dispatch(loadWorkingEvent(id, token!));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);

	useEffect(() => {
		const foundSession = workingEvent?.sessions.find(findSession(session));
		dispatch(loadWorkingSession(foundSession ?? null));
	}, [session, loadingEvent, workingEvent?.sessions, dispatch]);

	return !loading && workingSession && language ? (
		<Switch>
			<Route path={[PATHNAMES.Session.Session, PATHNAMES.Event.ThemeSession]}>
				<div className="session-wrapper" style={{ width: '100%' }}>
					<EventHeader />
					<div className="session-container">
						<Panel />
						<Editor />
					</div>
					<Assistant />
				</div>
			</Route>
			<Route>
				<Redirect to={PATHNAMES.Session.SessionLink(id, session, language)} />
			</Route>
		</Switch>
	) : (
		<div className="loading-page"><WaitingIndicator /></div>
	);
}
